import { z } from 'zod';
import { isoDate, uuid } from './common';

/** Who am I, and is step two done — the start screen's two questions. */
export const me = z.object({
  id: uuid,
  email: z.string(),
  name: z.string().nullable(),
  pictureUrl: z.string().nullable(),
  /** When the account was made. */
  createdAt: isoDate,
  /**
   * When this person was first back, twelve hours or more after making the
   * account — null while they are new. What's new is told only about
   * releases after it (2026-09-28): Vladimir, *"don't show new users modal
   * with release notes … only to those who really skipped some changes"*.
   * Optional only so a page loaded before the api that sends it still starts
   * — and a page that is not told treats the person as new.
   */
  returnedAt: isoDate.nullable().optional(),
  calendar: z.object({
    connected: z.boolean(),
    /** We already hold a Google grant with the calendar scope: connecting is one click. */
    grantReady: z.boolean(),
  }),
  /**
   * The free month (2026-09-26), for the banner that counts it down. Optional
   * only so a page loaded before the api that sends it still starts.
   */
  access: z
    .object({
      /** PAID says nothing; FREE counts down; ENDED: nothing is recorded for them. */
      state: z.enum(['PAID', 'FREE', 'ENDED']),
      /** When the free month ends (FREE) or when it — or an agreement — ended (ENDED). */
      endsAt: isoDate.nullable(),
      /** Whole days left, rounded up — the last day says 1. Null unless FREE. */
      daysLeft: z.number().int().nullable(),
      /** Whom their company writes to about an agreement. */
      contact: z.string().nullable(),
    })
    .optional(),
});
export type Me = z.infer<typeof me>;
